<template>
  <div class="block">
    <el-tag>vivo加粉账户拉停 </el-tag>
<!--    <div class="block">-->
<!--      <el-cascader-->
<!--        v-model="userUalue"-->
<!--        :options="options1"-->
<!--        filterable></el-cascader>-->
<!--    </div>-->
    <el-button @click="edit" v-if="dingshi" type="danger" size="small">紧急调整投放日期</el-button>

    <el-dialog title="修改开启时间" :visible.sync="dialog1">

      <el-tabs v-model="activeName1" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>


  </div>


</template>



<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from  '../until/excel';
export default {
  data() {
    return {
      textarea1:'',
      textarea2:'',
      planids:[],
      adid:[],
      dialog3:false,
      offer:false,
      form:{},
      xiane:true,
      activeName: 'first',
      activeName3:'first',
      activeName1: 'first',
      value3:'',
      dialog1:false,
      dialog:false,
      dialog2:false,
      valueFlag:0,
      flag:0,
      userUalue:'',
      isDisable:false,
      options1: [
        {
          value: 'xiaobai',
          label: '行长',
          children: [{
            value: 'mrqy',
            label: '河马阅读',
          },
            {
              value:'qexs',
              label: '企鹅小说',
            },{
              value: 'dzff',
              label: '点众付费',
            },{
              value: 'fhxs',
              label: '繁花小说',
            },
            {
              value: 'klxs',
              label: '考拉小说',
            },{
              value: 'ssxs',
              label: '松鼠小说',
            },{
              value: 'hmxs',
              label: '火苗小说',
            }
          ]
        },
      ],
      uuidListTest:[
        'be357e4b14f051bbeb79',
        '4534b3965d819327ed0d',
      ],
      tokenListTest:[
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
      ],

      uuidList:[
        'be357e4b14f051bbeb79',
        '4534b3965d819327ed0d',
        '73951706fd6cab90ba83',
        '28855c167a8102f90a4a',
        '20f34139c821aa7f2ef5',
        '7469041d6932d4fd95f5',
        '3eccdbdc39a5b9ba6c91',
        '446762b182a55b630421',
        '2aab315cbb0f7e4cb141',
        '3f0a0e07f2cadfd5dac9',
        'cdada238edba96639736',
        'ed61d3afca1fe20b88fd',
        '5222806911b41dc2adcb',
        'efe308849c4313ef175b',
        'ead90405a6f579d98fe0',
        '3fecc489902f59ee59c2',
        'e7799c3817da1260a1cc',
        'ca9c30ce82ecb7c274fd',
        '826f278f9d0ff57f1cef',
        '392333596d8283948672',
        'a926ebfb0a02f3f578bd',
        'f9c1f87cb57ec485fd8b',
        'aa09df75eca9ab91f347',
        '827c7249962c974cc8ec',
        'ac7bae3e3f1988a89983',
        'e561d1291aff93d6d2e5',
        '54589d7a892729813b49',
        '2f89c81db8fc395e89f2',
        '54fae66b9768d9473439',
        '1f983d93edf9f7674c1c',
        'ad0cdd10035550b0933b',
        '25285ff8aa190be524b6',
        'cf8eb703abf3a35c396f',
        '8c7501a9166980adb02f',
        '739cbde6964476e60a87',
        '001cc29d94c74736eb8b',
        '9d713dfb7a06b37c4aeb',
        'e9c972f7ad7fced9cb07',
        '335f6a9c4e16ae57d657',
        '8fae54e9507d11f63dbe',
        '636c0a1057af493ab5ad',
        '3b0d1f842d3b87038942',
        '7ffda0d926a8299e5504',
        'b5ffced50c412d62de10',
        '305666a9a53f9e64213e',
        '7279548e5544031f3457',
        '46e9507ce93d891612fa',
        'e80ef274d58a8ab11506',
        '490593eb58850b3dd118',
        '453c3dfcbacc4f43e073',
        'b61ac13b0988b23a12e4',
        '346ff8d7428942fbca14',
        '4a66daa3f9fadfc5b01c',
        'bb54144ae529cb9ff104',
        '782ae2917406f41a931d',
        '110f61dddcf17dc42d2b',
        '39482a293cd8d15c6d37',
        '02ec48fb526f6dc220c4',
        'ec864766ad2f5076ad22',
        '29beb177f3fc000034f0',
        '989f16281decc876340c',
        '0bfcd926b3e89fbaa470',
        'bdd69714545f2d1f2d87',
        '7d878cbdd86ace3af89f',
        'fdc91627a26a3d67dbcd',
        '3e1219c48f268ae2eddb',
        '52fde1234812a31c4dd8',
        '674a5969dd4b83114ef7',
        '263f84df8e3d258b00a3',
        '561c6f2edb4ea19dab69',
        '3220d070c7ae5bc9049d',
        '4854785dcff29d39ab2d',
        '692e7daa581911098f42',
        'bdbad38c58e6c5eab117',
        '44e7049e937067502733',
        '00d5a1465fca53c389d1',
        'e93fe2715f35f12c9aee',
        'b68d018a4bab77e29f99',
        '5b35915126e2ba1e234d',
        'f206ca6f07e6bf3a696d',
        'bea81108dafbf441c6b4',
        '11a0dc96d97565443924',
        '1f85de92a23cdb8cfa24',
        'ed8a1e5ae3c74d0dc99f',
        '50ff412bc4d482c9a424',
        '41ba1849c0ff4497a7a1',
        'e8b71ee56b771f802e06',
        '6e61c0f62865973b4333',
        '17d0614846bd23bcd7b6',
        'f52178fff2e2aec206c8',
        '5fe85847abd10873123d',
        '203fb3ba12aa282304eb',
        'c9f4feea5b7c8ba387f7',
        'f53fb5712288895fea1c',
        'd8aca465a4e4a524b7a0',
        '8e88ccbe67dcd7b33427',
        'd45ce0d3c9fb9e7244f6',
        'c7af0de05840f7ac446c',
        'bf76e2f3665fd1df2588',
        '64d38038434b163595ec',
        '516829fa963025278e35',
        'c0f1d8ef9a0f20a62af3',
        '79d0210099bcdfe7a0dd',
        'a7911b191bfa0d0fa1df',
        '6d9842ee4c6a2adfcf55',
        '1b7757627195685cf10d',
        '92565c16a8d76eb31c6c',
        '2ab880d734756e7f72dc',
        '56bfcbbfc8037683b58b',
        'dd3df2125532ab9ceaf6',

      ],
      tokenList:[
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        '838f4a59c3100d0cefd59d8984db049284d7b9bfe6449cecc8ae7b7d1e84cad2',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'd6e58256d0c9e32e049505873eb976b97fc2b787bb9b5fdfcad38cae40c7a152',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        'f550918fe56c787e16e30b7cfd66b35d139cd8b02932e408ee0d2e7bc0c1e943',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        'fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81',
        'fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81',
        'fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81',
        'fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81',
        'fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81',
        'fd91d2374a41522e41efdeadc0c53a43c3237801945bd781387c267990632b81',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        '953057aaf6fa039b7c5090c613ea314d8b678109317ea6dabe5524644f2b06f5',
        'fdab982e574007f76c1bb9f4bd057fda2622d2b4d45de5f8c3835615710c283b',
        'fdab982e574007f76c1bb9f4bd057fda2622d2b4d45de5f8c3835615710c283b',
        'fdab982e574007f76c1bb9f4bd057fda2622d2b4d45de5f8c3835615710c283b',
        'fdab982e574007f76c1bb9f4bd057fda2622d2b4d45de5f8c3835615710c283b',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137558e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137559e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137560e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137561e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137562e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
        '48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',

      ],


      options: [{
        value: 'DAY',
        label: '按天汇总'
      },
        {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      /*
      小邱
       */
      xiaobai:['6dc95a3defa9966711cd4722521bd7c9cf0d4ea90655e8f07bdbf2f50a263955','c76459da2362e48013633cb91913ba3c38e1527e7ef55894836704101232321d','34e86c1ff5d892d596ee71e5af2127aa44e8abbd1dd2d15b62007263c14d84a1','ad3e1110b63f65bcbcf182afed0171547c45341a97a5897793ec722b3b92cc73','96583eebdfe6abc8d6d7f60770a419d6ce850eecb4ddd94de95a0915851c7cb2','b2021802e714197beb33b9814a07ba782863f12dc5025dc9198201c8fe41fb42','99ad52c9f6ffc7df551d6996d94d8717d3aaba4cd4ba7c0552744fb861709fe9'],


      //数据
      dingshi:true,
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      temp3:[],

      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      qiliangcode:0,
      sks:'',
      list:[],
      money:200,
      money2:0.5,
      money3:0.0,
      moneys:0.0,
      max:0,
      ctrJson:[{
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      Newswicth:[],
      map:new Map,
      groudId:[],
      kaiguan:0,
      adids:'',
      numtest:[],
      planid:[],
      groudId1:[],
    }
  },
  methods:{
    async updateEd() {
      if (this.kaiguan === 0) {
        for(let keys in this.planids){
          this.groudId=[]
          let pams={
            //危险
            token:this.sks,
            adid:this.adid[keys],
            campaignId:this.planids[keys]
          }
          this.adids=this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }


      } else if (this.kaiguan === 1) {
        for(let keys in this.planids){
          this.groudId=[]
          let pams={
            //危险
            token:this.sks,
            adid:this.adid[keys],
            campaignId:this.planids[keys]
          }
          this.adids=this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 2) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 3) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000001111111111111111111111111000000000000000000000001111111111111111111111111000000000000000000000001111111111111111111111111000000000000000000000001111111111111111111111111000000000000000000000001111111111111111111111111000000000000000000000001111111111111111111111111000000000000000000000001111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 4) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 5) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 6) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 7) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 8) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 9) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 10) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      } else if (this.kaiguan === 11) {
        for(let keys in this.planids) {
          this.groudId = []
          let pams = {
            //危险
            token: this.sks,
            adid: this.adid[keys],
            campaignId: this.planids[keys]
          }
          this.adids = this.adid[keys]
          await this.PostGroup3(pams)
          for (let a = 0; a < this.groudId.length; a++) {
            let parm = {
              token: this.sks,
              adid: this.adids,
              ids: this.groudId[a],
              scheduleTime: '000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111'
            }
            await this.PostGroupTime(parm)
          }
        }
      }

    },
    async offPlan(){
      if (this.userUalue[1]==="mrqy"){
        this.sks=this.xiaobai[0]
      }else if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
      }else if (this.userUalue[1]==="fhxs"){
        this.sks=this.xiaobai[3]
      }else if (this.userUalue[1]==="klxs"){
        this.sks=this.xiaobai[4]
      }else if (this.userUalue[1]==="ssxs"){
        this.sks=this.xiaobai[5]
      }else if (this.userUalue[1]==="hmxs"){
        this.sks=this.xiaobai[6]
      }
      this.planids=this.textarea2.trim().split(/\n/);
      this.adid=this.textarea1.trim().split(/\n/);
      for (let keys in this.planids){
        let parms={
          //危险
          token: this.sks,
          adid:this.adid[keys],
          campaignId:this.planids[keys],
          startAndStop:1
        }
        await this.offPlanId(parms);
      }
    },
    async onPlan(){
      if (this.userUalue[1]==="mrqy"){
        this.sks=this.xiaobai[0]
      }else if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
      }else if (this.userUalue[1]==="fhxs"){
        this.sks=this.xiaobai[3]
      }else if (this.userUalue[1]==="klxs"){
        this.sks=this.xiaobai[4]
      }else if (this.userUalue[1]==="ssxs"){
        this.sks=this.xiaobai[5]
      }else if (this.userUalue[1]==="hmxs"){
        this.sks=this.xiaobai[6]
      }
      this.planids=this.textarea2.trim().split(/\n/);
      this.adid=this.textarea1.trim().split(/\n/);
      for (let keys in this.planids){
        let parms={
          //危险
          token:this.sks,
          adid:this.adid[keys],
          campaignId:this.planids[keys],
          startAndStop:0
        }
        await this.offPlanId(parms);
      }
    },
    async offGround(){
      console.log(this.userUalue[1])
      if (this.userUalue[1]==="mrqy"){
        this.sks=this.xiaobai[0]
      }else if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
      }else if (this.userUalue[1]==="fhxs"){
        this.sks=this.xiaobai[3]
      }else if (this.userUalue[1]==="klxs"){
        this.sks=this.xiaobai[4]
      }else if (this.userUalue[1]==="ssxs"){
        this.sks=this.xiaobai[5]
      }else if (this.userUalue[1]==="hmxs"){
        this.sks=this.xiaobai[6]
      }
      this.planids=this.textarea2.trim().split(/\n/);
      this.adid=this.textarea1.trim().split(/\n/);
      for (let keys in this.planids){
        let parms={
          //危险
          token: this.sks,
          adid:this.adid[keys],
          campaignId:this.planids[keys],
          startAndStop:1
        }
        await this.offGoundId(parms);
      }
    },
    async onGround(){
      if (this.userUalue[1]==="mrqy"){
        this.sks=this.xiaobai[0]
      }else if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
      }else if (this.userUalue[1]==="fhxs"){
        this.sks=this.xiaobai[3]
      }else if (this.userUalue[1]==="klxs"){
        this.sks=this.xiaobai[4]
      }else if (this.userUalue[1]==="ssxs"){
        this.sks=this.xiaobai[5]
      }else if (this.userUalue[1]==="hmxs"){
        this.sks=this.xiaobai[6]
      }
      this.planids=this.textarea2.trim().split(/\n/);
      this.adid=this.textarea1.trim().split(/\n/);
      for (let keys in this.planids){
        let parms={
          //危险
          token:this.sks,
          adid:this.adid[keys],
          campaignId:this.planids[keys],
          startAndStop:0
        }
        await this.offGoundId(parms);
      }
    },
    //投放日期
    async edit(row){

      console.log(this.data)

      this.dialog1=true;

    },

    /**一键起量
     *
     *
     * @param pams
     * @returns {Promise<void>}
     * @constructor
     */
    async Postoffer1(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/updateFastFlow?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupId":pams.id,
          "fastFlowBudget":pams.ocpxPrice,
          "fastFlowState":pams.price
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '一键起量失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '一键起量成功',
            type: 'success'
          });

        }

      })


    },
    async Postoffer(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditPrice?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.id,
          "ocpxPrice":pams.ocpxPrice,
          "price":pams.price
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改二阶段出价失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改二阶段出价成功',
            type: 'success'
          });

        }

      })


    },
    SendOffer(){
      console.log(this.groudId)
      let t2=this.money3*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:t3,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer(t1)
      }

      this.offer=false
    },
    SendOffer1(){
      console.log(this.groudId)
      let t2=this.moneys*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:1,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer=false
    },
    SendOffer2(){
      console.log(this.groudId)
      let t2=this.moneys*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:3,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer=false
    },
    async chujia(index, row) {
      this.money3=0;
      this.max=0;
      let pams = {
        //危险
        token: this.sks,
        adid: row.uuid,
        adName: row.adName,
        campaignId: row.campaignId
      }
      this.adids = row.uuid
      await this.PostGroup3(pams)
      await this.yijianqiliangcode(pams)

      this.max=this.numtest[0].ocpxPrice;
      if (this.numtest.length=1){
        this.money3=this.numtest[0].ocpxPrice;
      }else{
        for (let i=1;i<this.numtest.length;i++){
          console.log(this.numtest[i].ocpxPrice)
          if(this.numtest[i].ocpxPrice>this.max){
            this.money3=this.numtest[i].ocpxPrice;
          }else{
            this.money3=this.max

          }

        }
      }

      this.money3=this.money3/100000
      this.offer = true;
    },
    updateEd1(){
      console.log(this.kaiguan)
      if(this.kaiguan===0){
        let t1={
          id:this.grouplist.campaignId,
          dailyBudget:-1,
          token:this.sks,
          adid:this.grouplist.userId
        }
        this.PostMoeny(t1)
      }else if (this.kaiguan===1){
        let t1={
          id:this.grouplist.campaignId,
          dailyBudget:this.money*100000,
          token:this.sks,
          adid:this.grouplist.userId
        }
        this.PostMoeny(t1)


      }



      this.dialog2=false

    },

//修改限额api
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog2=true
    },
    async PostMoeny(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });

        }

      })


    },
    async yijianqiliangcode(pams){
      this.groudId1=[]
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/getFastFlowInfoByGroupIds?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupIds":this.groudId[0],
        }).then(resp=>{
        // console.log(resp.data[0].fastFlowState)
        if (resp.data.data===undefined){
          this.qiliangcode=0;
        }else {
          console.log(resp.data.data)
          this.qiliangcode=resp.data.data[0].fastFlowState;


        }
        // if (resp.data.datas[0])
      })


    },
    async PostGroup1(pams){

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })


    },
    async updateTime1() {
      // for(let a=0;a<this.datas.length;a++){
      //   console.log(this.datas[a].uuid)
      // }
      for (let a = 0; a < this.datas.length; a++) {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: this.datas[a].uuid,
        }
        // console.log(parms)
        await this.queryPlanId(parms)
        console.log(this.planid)
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid: this.datas[a].uuid,
            campaignId:this.planid[key],
          }
          this.adids = this.datas[a].uuid,
            await this.PostGroup4(pams)

          // console.log(this.groudId)
        }
        let endtime = '2038-01-19'
        if (this.kaiguan === 0) {
          //发送
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value3,
              endDate: endtime,
              token: this.sks,
              adid: this.adids
            }

            await this.PostGroup1(pams)
          }

        } else if (this.kaiguan === 1) {
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value2.at(0),
              endDate: this.value2.at(1),
              token: this.sks,
              adid: this.adids
            }
            await  this.PostGroup1(pams)
          }
        }
        if(a===this.datas.length-1){
          alert("批量关闭OK")
          this.dialog3 = false
        }
      }

    },
    //投放时间方法提交
    async updateTime() {

      let endtime = '2038-01-19'
      if (this.kaiguan === 0) {
        for (let key in this.uuidList){
          let pams={
            uid:this.uuidList[key],
            token:this.tokenList[key],
            startDate: this.value3,
            endDate: endtime,

          }
          await this.PostGroup4(pams);
        }



      } else if (this.kaiguan === 1) {
        for (let key in this.uuidList){
          let pams={
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            uid:this.uuidList[key],
            token:this.tokenList[key]
          }
          await this.PostGroup4(pams);
          //获取广告组id
          //设置广告组投放时间
        }

      }
      this.$notify({
        title: '已经全部拉停',
        message: '调整全体账户投放日期成功',
        type: 'success'
      });
      this.dialog1 = false
    },
    //面板状态

    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }else if (tab.name==="two"){
        this.kaiguan=2
      }else if(tab.name==="second1"){
        this.kaiguan=3
      }else if(tab.name==="second2"){
        this.kaiguan=4
      }else if(tab.name==="second3"){
        this.kaiguan=5
      }else if(tab.name==="second4"){
        this.kaiguan=6
      }else if(tab.name==="second5"){
      }else if(tab.name==="second5"){
        this.kaiguan=7
      }else if(tab.name==="two2"){
        this.kaiguan=8
      }else if(tab.name==="two4"){
        this.kaiguan=9
      }else if(tab.name==="two5"){
        this.kaiguan=10
      }
      else if(tab.name==="two6"){
        this.kaiguan=11
      }






    },
    //修改日期
    async PostGroupTime(pams){

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "scheduleTime":pams.scheduleTime,

        }).then(resp=>{

        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放时段失败，请检查时段是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放时段成功',
            type: 'success',
            position: 'bottom-left'
          });
          this.dialog=false
        }

      })


    },
    async PostGroup2(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list){
          // this.groudId[key]=resp.data.data.list[key].groupId
          this.groudId.push(resp.data.data.list[key].groupId)
        }

      })

    },
    async PostGroup(pams){
      this.groudId=[]

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list){
          this.groudId[key]=resp.data.data.list[key].groupId
        }

      })

    },
    async PostGroup4(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.uid,
        {
          "pageSize":100,
        }).then(async  resp=>{
      // for (let key in resp.data.data.list){
        let ids = resp.data.data.list.map(item => item.id).join(",");

        let parm= {
            ids:ids,
            token:pams.token,
            adid:pams.uid,
          startDate: pams.startDate,
          endDate: pams.endDate,
        }
        await this.PostGroup1(parm)
      // }

      })
    },
    async PostGroup3(pams){
      this.groudId=[]
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        for (let key in resp.data.data.list){

          this.groudId[key]=resp.data.data.list[key].id
        }
        this.numtest=resp.data.data.list

      })
    },
    //投放时间
    //批量启停计划
    async offPlanId(parms){
      let time = parseInt(new Date().getTime()) + '';

      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        "ids": parms.campaignId,
        "startAndStop": parms.startAndStop
      }).then(async resDay => {
        if (parms.startAndStop===1){
          this.$notify({
            title: '成功',
            message: '批量关闭计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        }else if(parms.startAndStop===0){
          this.$notify({
            title: '成功',
            message: '批量开启计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })

    },
    //批量启停广告组
    async offGoundId(parms){
      let time = parseInt(new Date().getTime()) + '';

      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pause/toggle?access_token=' + parms.token + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        "ids": parms.campaignId,
        "startAndStop": parms.startAndStop
      }).then(async resDay => {
        if (parms.startAndStop===1){
          this.$notify({
            title: '成功',
            message: '批量关闭计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        }else if(parms.startAndStop===0){
          this.$notify({
            title: '成功',
            message: '批量开启计划成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })

    },
    //查询计划
    async queryPlanId(parms){
      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        pageSize:'100'
      }).then(async resDay => {

        for (let key in resDay.data.data.list){

          this.planid[key]=resDay.data.data.list[key].id
        }

      })

    },
    //显示表单
    async handleClick(row) {
      if (this.userUalue[1]==="mrqy"){
        this.sks=this.xiaobai[0]
      }else if (this.userUalue[1]="qexs"){
        this.sks=this.xiaobai[1]
      }else if (this.userUalue[1]="fhxs"){
        this.sks=this.xiaobai[3]
      }else if (this.userUalue[1]="klxs"){
        this.sks=this.xiaobai[4]
      }else if (this.userUalue[1]="ssxs"){
        this.sks=this.xiaobai[5]
      }else if (this.userUalue[1]="hmxs"){
        this.sks=this.xiaobai[6]
      }
      this.dialog = true;
      this.planids=this.textarea2.trim().split(/\n/);
      this.adid=this.textarea1.trim().split(/\n/);




    },

    //切换开关
    changeSwitch(value,row,index){
      if (this.userUalue[1]==="mrqy") {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }else {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }

    },
    //汇总 格式化合计行
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总汇';
          return;
        }
        if (index === 9){
          sums[index] = ''

          return;

        }

        if (index === 10){
          sums[index] = sums[index-2]/sums[index-4];
          sums[index]=sums[index].toFixed(4);
          return;

        }

        if (index === 14){
          sums[index] = sums[index-6]/sums[index-1];
          sums[index]=sums[index].toFixed(4);
          return;

        }

        if (index === 16) {
          sums[index] = sums[index-8]/sums[index-11];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]*100+'%'
          return;

        }
        if (index === 17) {
          sums[index] = sums[index-4]/sums[index-11];
          sums[index]=sums[index].toFixed(4);
          sums[index]=sums[index]*100+'%'
          return;

        }


        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //导出文档api
    exportExcel() {
      excel('exportTab','数据导出')
    },


    //表单格式规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    //加百分号
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    rule1(row,column){

      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },
    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      this.value2=value1;

    },
    //查询函数
    async getDataList1(){
      this.dialog3=true

    },
    getDataList() {
      //清空列表，数组
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]

      //判断是否为小白进入下方，查询按钮禁用
      if(this.userUalue[0]==="xiaobai"){
        this.isDisable = true
        //调起接口
        this.TimeChangeto1();
      }

    },
    //合并json
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },
    //按天查询所有户
    async queryDay(list){
      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + list.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + list.adid[list.a], {
        startDate: list.startDate,
        endDate: list.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: "DAY",
        level: list.level
      }).then(async resDay => {
        this.len=resDay.data.data.items.length;
        return resDay;
      })
    },
    //查询广告
    async PostListQuery(parms){

      this.$message.success("正在查询第"+parms.a+"条")
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
        if (resp.data.code!==60806){
          if (resp.data.data.items !=null){
            if (this.value==="HOUR"){
              let arr=[];
              arr=[];
              let map=new Map;
              map.clear();
              for(let key in resp.data.data.items){
                var time=new Date(resp.data.data.items[key].reportTime)
                let reTimeHour=time.getHours(); //获取返回整点时间
                var date=new Date()
                let hour=date.getHours();  // 获取当前时间
                if (hour===reTimeHour){
                  arr.push(key)   //定位现在整时位置
                  map.set(key,resp.data.data.items[key])// 记录下现在的数据
                }
              }
              for (let keys in arr){

                this.datadata.push(map.get(arr[keys]))
                let obj={
                  ids:resp.data.data.items[arr[keys]].campaignId,
                  lengths:arr.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:arr.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }else{
              for (let b=0;b<resp.data.data.items.length;b++){
                this.datadata.push(resp.data.data.items[b])
                let obj={
                  ids:resp.data.data.items[b].campaignId,
                  lengths:resp.data.data.items.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:resp.data.data.items.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }

          }
        }

      })

    },
    // 查询计划状态
    async PostListplayCode(pams){

      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    //查询账号信息
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {

            }
          }

        )
    },
    //服务请求
    async TimeChangeto1 () {
      //判断是哪个户
      this.sks=this.xiaobai[0]
      if (this.userUalue[1]==="mrqy"){
        for (let a = 0; a < this.mrqy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.mrqy
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].disGeneralBalance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
        for (let a = 0; a < this.qexs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.qexs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].disGeneralBalance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="dzff"){
        this.sks=this.xiaobai[2]
        for (let a = 0; a < this.dzff.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.dzff
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].disGeneralBalance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false
      }
    },
  },
  created () {  },
}
</script>



// WEBPACK FOOTER //
// src/components/planStop.vue